import { IS_RECURRING_NO, IS_RECURRING_YES } from '../../edit-listing/common/config/sessions';

/**
 * The two free shapes, keyed off publicData. Older listings store `isRecurring` as a
 * boolean, newer ones as 'yes'/'no' — hence the pair of checks rather than `!== 'no'`,
 * which would read a listing with no `isRecurring` at all as recurring.
 */
const freeSingleEvent = (publicData = {}) =>
  publicData?.isRecurring === IS_RECURRING_NO && !!publicData?.singleEvent?.isFreeClass;

/**
 * A recurring listing whose block booking is free (CH-508). Lives under `blockBooking`
 * rather than beside `singleEvent.isFreeClass` so the price config and its free flag stay
 * in one object — `lineItems.js` reads both out of `publicData[ticketOptionKey]`.
 */
const freeBlockBooking = (publicData = {}) =>
  (publicData?.isRecurring === IS_RECURRING_YES || publicData?.isRecurring === true) &&
  !!publicData?.blockBooking?.isFreeClass;

export const isFreeListing = (listing) => freeSingleEvent(listing?.attributes?.publicData);

export const isFreeBlockBookingListing = (listing) =>
  freeBlockBooking(listing?.attributes?.publicData);

/** No money changes hands, whichever shape the listing is. */
export const isFreeBookingListing = (listing) =>
  isFreeListing(listing) || isFreeBlockBookingListing(listing);

/** Same question, for the price components, which are handed publicData rather than a listing. */
export const isFreePublicData = (publicData) =>
  freeSingleEvent(publicData) || freeBlockBooking(publicData);
